import styled from '@emotion/styled';
import { COLORS, BREAKPOINTS } from './variables';

export const MaxWidthWrapper = styled.div`
  max-width: 1242px;
  margin: 0 auto;
`;
